import { useStaffById } from '@/services/staff/useStaffById';
import { FC } from 'react';
import { FiEdit } from 'react-icons/fi';
import { useParams } from 'react-router-dom';
import { PageContainer } from '../../../../../components/page/PageContainer';
import { PageHeader } from '../../../../../components/page/PageHeader';
import { PageSizer, SizerMode } from '../../../../../components/page/PageSizer';
import { breadcrumbName } from '../../../../../helpers/Utility';
import { strings as timeshiftStrings } from '../../../../../services/translation/strings';
import strings from '../../../team.translations';
import { TeamMemberContractEditForm } from './TeamMemberContractEditForm';

interface TeamMemberPermissionsEditProps {}

export const TeamMemberContractEdit: FC<TeamMemberPermissionsEditProps> = () => {
  const { userId } = useParams<'userId'>();
  if (!userId) {
    throw new Error('User ID is required');
  }

  const userData = useStaffById(userId);

  if (!userData) throw new Error(`Staff with id ${userId} not found`);

  const breadcrumbs = [
    {
      name: strings.teamPageTitle,
      to: '/team'
    },
    {
      name: breadcrumbName(userData, strings.employeeName),
      to: `/team-member/${userId}`
    },
    {
      name: timeshiftStrings.timeshift.teamMember.contractDetails.edit,
      to: `/team-member/${userId}/edit-permissions`
    }
  ];

  return (
    <PageContainer>
      <PageHeader
        icon={<FiEdit />}
        pageTitle={
          timeshiftStrings.timeshift.teamMember.contractDetails.edit +
          ': ' +
          `${userData.firstName + ' ' + userData.lastName}`
        }
        breadcrumbs={breadcrumbs}
      />
      <PageSizer mode={SizerMode.PAGE}>
        <div className="py-5">
          <TeamMemberContractEditForm employee={userData} />
        </div>
      </PageSizer>
    </PageContainer>
  );
};
